<template>

    <div>
        <van-nav-bar :title="title" >
        </van-nav-bar>
        <van-tabs v-model="active" sticky>
            <van-tab  title="聊天统计">
                <talk-statistics></talk-statistics>
            </van-tab>
        </van-tabs>
    </div>

</template>

<script>

    import FinDayStatistics from "./FinDayStatistics";
    import FinMonthStatistics from "./FinMonthStatistics";
    import TalkStatistics from "./TalkStatistics";
    export default {
        name: "FinStatistics",
        components: {
            FinMonthStatistics,
            FinDayStatistics,
            TalkStatistics
        },
        data(){
            return {
                title:'统计',
                active:0

            }
        }



    }
</script>

<style scoped>

</style>
